/**
 * @generated SignedSource<<539eec336d250a74a53d1421b69d4091>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type TryOnType = "BRACELET" | "EARRINGS" | "EYEWEAR" | "HEADWEAR" | "NECKLACE" | "NOT_SELECTED" | "SCARVES" | "SHOES" | "WATCHES";
export type existingSceneDataWithSceneQuery$variables = {
  sceneId: string;
};
export type existingSceneDataWithSceneQuery$data = {
  readonly scene: {
    readonly cameraLimitLowerRadius: boolean;
    readonly cameraLocations: ReadonlyArray<{
      readonly locationID: any;
      readonly name: string;
      readonly px: number;
      readonly py: number;
      readonly pz: number;
      readonly tx: number;
      readonly ty: number;
      readonly tz: number;
    }>;
    readonly cameraPositionScale: number | null;
    readonly config: {
      readonly animations: {
        readonly loop: boolean | null;
        readonly runAtStart: boolean | null;
        readonly speed: number | null;
      } | null;
      readonly camera: {
        readonly animateIntro: boolean | null;
        readonly autoRotate: boolean | null;
        readonly changeRotationDirection: boolean | null;
        readonly contrast: number | null;
        readonly exposure: number | null;
        readonly fixedAlphaAngle: number | null;
        readonly fixedBetaAngle: number | null;
        readonly initialZoomToBBInertiaDamping: number | null;
        readonly initialZoomToBBModelSizeRadius: number | null;
        readonly initialZoomToBBScrollLowerLimit: number | null;
        readonly initialZoomToBBScrollUpperLimit: number | null;
        readonly initialZoomToBBScrollZoomEnabled: boolean | null;
        readonly limitLowerRadius: boolean | null;
        readonly lowerAlphaLimit: number | null;
        readonly lowerBetaLimit: number | null;
        readonly maxZoomPerc: number | null;
        readonly minZoomPerc: number | null;
        readonly position: {
          readonly alpha: number | null;
          readonly beta: number | null;
          readonly fov: number | null;
          readonly radius: number | null;
        } | null;
        readonly positionScale: number | null;
        readonly rotationSpeed: number | null;
        readonly setInitialZoomToBoundingBox: boolean | null;
        readonly toneMappingEnabled: boolean | null;
        readonly toneMappingType: number | null;
        readonly upperAlphaLimit: number | null;
        readonly upperBetaLimit: number | null;
        readonly useLowerAlphaLimit: boolean | null;
        readonly useLowerBetaLimit: boolean | null;
        readonly useMaxZoomPerc: boolean | null;
        readonly useMinZoomPerc: boolean | null;
        readonly useUpperAlphaLimit: boolean | null;
        readonly useUpperBetaLimit: boolean | null;
        readonly zoom: number | null;
        readonly zoomEnabled: boolean | null;
      } | null;
      readonly environment: {
        readonly backgroundColor: string | null;
        readonly ground: {
          readonly color: string | null;
          readonly createGround: boolean;
          readonly enableMirror: boolean | null;
          readonly enableShadow: boolean | null;
          readonly mirrorBlurKernel: number | null;
          readonly opacity: number | null;
          readonly shadowLevel: number | null;
          readonly size: number | null;
          readonly texture: string | null;
        } | null;
        readonly mainColor: string | null;
        readonly shadows: {
          readonly blurBoxOffset: number | null;
          readonly blurKernel: number | null;
          readonly blurScale: number | null;
          readonly contactHardeningUVRatio: number | null;
          readonly depthScale: number | null;
          readonly enableShadows: boolean | null;
          readonly groundSizeMultiplierLength: number | null;
          readonly groundSizeMultiplierWidth: number | null;
          readonly shadowDarkness: number | null;
          readonly shadowHexColor: string | null;
          readonly shadowMapSize: number | null;
          readonly shadowMaxZ: number | null;
          readonly shadowMinZ: number | null;
          readonly useBlurCloseExponentialShadowMap: boolean | null;
          readonly useContactHardeningShadow: boolean | null;
          readonly useKernelBlur: boolean | null;
          readonly usePercentageCloserFiltering: boolean | null;
          readonly usePoissonSampling: boolean | null;
        } | null;
        readonly sizeAuto: boolean | null;
        readonly skybox: {
          readonly blur: number;
          readonly color: string | null;
          readonly createSkybox: boolean;
          readonly extensions: ReadonlyArray<string | null> | null;
          readonly files: ReadonlyArray<string | null> | null;
          readonly size: number | null;
          readonly texture: string | null;
        } | null;
      } | null;
      readonly general: {
        readonly antialias: {
          readonly desktop: {
            readonly enabled: boolean | null;
            readonly inRotationEnabled: boolean | null;
          } | null;
          readonly mobile: {
            readonly enabled: boolean | null;
            readonly inRotationEnabled: boolean | null;
          } | null;
        } | null;
        readonly antialiasEnabled: boolean | null;
        readonly arAnchor: string | null;
        readonly arEnabled: boolean | null;
        readonly arOnTheFly: boolean | null;
        readonly arScale: boolean | null;
        readonly backgroundAlpha: number | null;
        readonly backgroundColor: string | null;
        readonly contrast: number | null;
        readonly environmentOptions: {
          readonly gammaSpace: boolean | null;
          readonly generateHarmonics: boolean | null;
          readonly intensity: number | null;
          readonly mipMaps: boolean | null;
          readonly pbrIntensity: number | null;
          readonly prefilterOnLoad: boolean | null;
          readonly rotationY: number | null;
        } | null;
        readonly environmentTexture: string | null;
        readonly exposure: number | null;
        readonly fitToScreenMargin: number | null;
        readonly forceDracoCompression: boolean | null;
        readonly frameDAMSettings: string | null;
        readonly matchSameNameTextures: boolean | null;
        readonly meshSize: {
          readonly depth: number | null;
          readonly height: number | null;
          readonly width: number | null;
        } | null;
        readonly prefetchMaterials: boolean | null;
        readonly prefetchMeshes: boolean | null;
        readonly preventDefaultLights: boolean | null;
        readonly removeDefaultBackground: boolean | null;
        readonly tryOnEnabled: boolean | null;
        readonly tryOnSettings: {
          readonly buttonCustomizations: ReadonlyArray<{
            readonly backgroundColor: string | null;
            readonly borderColor: string | null;
            readonly borderRadius: number | null;
            readonly borderWidth: number | null;
            readonly image: string | null;
            readonly textColor: string | null;
            readonly textLabel: string | null;
          } | null> | null;
          readonly styleButton: string | null;
          readonly type: TryOnType;
          readonly typeSettings: {
            readonly active: boolean | null;
            readonly mandatoryPD: boolean | null;
            readonly pd: boolean | null;
            readonly try_on: boolean | null;
          } | null;
        } | null;
        readonly useDelayedMaterialLoading: boolean | null;
        readonly useDelayedTextureLoading: boolean | null;
        readonly useMaterialOffloading: boolean | null;
      } | null;
      readonly glow: {
        readonly blurSize: number | null;
        readonly enabled: boolean;
        readonly intensity: number | null;
      } | null;
      readonly infoPoints: {
        readonly enabled: boolean;
        readonly pointsStyle: {
          readonly borderColor: string | null;
          readonly color: string | null;
          readonly highlightColor: string | null;
          readonly innerPointColor: string | null;
        } | null;
      } | null;
      readonly lights: {
        readonly directionalLightBack: {
          readonly general: {
            readonly intensity: number | null;
            readonly visible: boolean | null;
          } | null;
          readonly position: {
            readonly x: number | null;
            readonly y: number | null;
            readonly z: number | null;
          } | null;
        } | null;
        readonly directionalLightLeft: {
          readonly general: {
            readonly intensity: number | null;
            readonly visible: boolean | null;
          } | null;
          readonly position: {
            readonly x: number | null;
            readonly y: number | null;
            readonly z: number | null;
          } | null;
        } | null;
        readonly hemisphereLight: {
          readonly general: {
            readonly intensity: number | null;
            readonly visible: boolean | null;
          } | null;
          readonly position: {
            readonly x: number | null;
            readonly y: number | null;
            readonly z: number | null;
          } | null;
        } | null;
        readonly pointLightBack: {
          readonly general: {
            readonly intensity: number | null;
            readonly visible: boolean | null;
          } | null;
          readonly position: {
            readonly x: number | null;
            readonly y: number | null;
            readonly z: number | null;
          } | null;
        } | null;
        readonly pointLightFront: {
          readonly general: {
            readonly intensity: number | null;
            readonly visible: boolean | null;
          } | null;
          readonly position: {
            readonly x: number | null;
            readonly y: number | null;
            readonly z: number | null;
          } | null;
        } | null;
      } | null;
      readonly model: {
        readonly config: {
          readonly doubleSided: boolean | null;
        } | null;
        readonly position: {
          readonly x: number | null;
          readonly y: number | null;
          readonly z: number | null;
        } | null;
        readonly rotation: {
          readonly x: number | null;
          readonly y: number | null;
          readonly z: number | null;
        } | null;
        readonly scale: {
          readonly x: number | null;
          readonly y: number | null;
          readonly z: number | null;
        } | null;
      } | null;
      readonly textures: {
        readonly format: string | null;
        readonly webpOptions: {
          readonly quality: number;
          readonly type: string | null;
        } | null;
      } | null;
      readonly uiConfig: {
        readonly urlARIcon: string | null;
        readonly urlLoader: string | null;
      } | null;
    } | null;
    readonly fileLength: number | null;
    readonly fileObjectID: number | null;
    readonly id: string;
    readonly imageData: string | null;
    readonly imageFileLength: number;
    readonly imageUrl: string;
    readonly incrementalsFileLength: number | null;
    readonly incrementalsFileObjectID: number | null;
    readonly incrementalsFileUrl: string;
    readonly manifestFileLength: number | null;
    readonly manifestFileObjectID: number | null;
    readonly manifestFileUrl: string;
    readonly materialMappings: ReadonlyArray<{
      readonly libraryMaterialID: any;
      readonly sceneMaterialID: any;
    }>;
    readonly materialPhotos: ReadonlyArray<{
      readonly displayOrder: number;
      readonly fileLength: number | null;
      readonly fileObjectID: number | null;
      readonly materialID: any;
      readonly photoID: any;
      readonly url: string;
    }>;
    readonly meshLocations: ReadonlyArray<{
      readonly adjustCamera: boolean;
      readonly data: ReadonlyArray<any>;
      readonly displayOrder: number;
      readonly imageUrl: string;
      readonly isCollapsed: boolean;
      readonly isExploded: boolean;
      readonly locationID: any;
      readonly name: string;
      readonly tempImageFileKey: string;
      readonly tempImageFileUrl: string;
    }>;
    readonly name: string;
    readonly rootUrl: string;
    readonly sceneFileName: string;
    readonly sceneID: any;
    readonly sceneIDforPagination: number;
    readonly sellerID: number;
    readonly shaderMaterials: ReadonlyArray<{
      readonly fragment: string;
      readonly materialID: any;
      readonly name: string;
      readonly vertex: string;
    }>;
    readonly sources: ReadonlyArray<{
      readonly fileLength: number | null;
      readonly fileObjectID: number | null;
      readonly rootUrl: string;
      readonly sceneFileName: string;
      readonly sourceID: any;
      readonly textures: ReadonlyArray<{
        readonly fileLength: number | null;
        readonly fileObjectID: number | null;
        readonly textureID: any;
        readonly url: string;
      }>;
      readonly url: string;
    }>;
    readonly tempSceneID: any;
    readonly textures: ReadonlyArray<{
      readonly fileLength: number | null;
      readonly fileObjectID: number | null;
      readonly isDefaultEnvironment: boolean;
      readonly materialID: any;
      readonly textureID: any;
      readonly url: string;
      readonly usage: number;
    }>;
    readonly url: string;
    readonly useDefaultEnvironmentTexture: boolean;
    readonly usedTextureUrls: ReadonlyArray<string> | null;
    readonly version: number;
  };
};
export type existingSceneDataWithSceneQuery = {
  response: existingSceneDataWithSceneQuery$data;
  variables: existingSceneDataWithSceneQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "sceneId"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "fileObjectID",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "url",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "rootUrl",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "sceneFileName",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "fileLength",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "imageUrl",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "backgroundColor",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "intensity",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "type",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "borderColor",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "exposure",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "contrast",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "enabled",
  "storageKey": null
},
v15 = [
  (v14/*:: as any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "inRotationEnabled",
    "storageKey": null
  }
],
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "size",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "texture",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "color",
  "storageKey": null
},
v19 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "x",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "y",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "z",
    "storageKey": null
  }
],
v20 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "SceneLightPosition",
    "kind": "LinkedField",
    "name": "position",
    "plural": false,
    "selections": (v19/*:: as any*/),
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "SceneLightGeneral",
    "kind": "LinkedField",
    "name": "general",
    "plural": false,
    "selections": [
      (v9/*:: as any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "visible",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
],
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "textureID",
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "locationID",
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "materialID",
  "storageKey": null
},
v24 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "displayOrder",
  "storageKey": null
},
v25 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "sceneId"
      }
    ],
    "concreteType": "Scene",
    "kind": "LinkedField",
    "name": "scene",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "sceneIDforPagination",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "sceneID",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "tempSceneID",
        "storageKey": null
      },
      (v1/*:: as any*/),
      (v2/*:: as any*/),
      (v3/*:: as any*/),
      (v4/*:: as any*/),
      (v5/*:: as any*/),
      (v6/*:: as any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "manifestFileObjectID",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "manifestFileUrl",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "manifestFileLength",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "incrementalsFileObjectID",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "incrementalsFileUrl",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "incrementalsFileLength",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "sellerID",
        "storageKey": null
      },
      (v7/*:: as any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "imageData",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "imageFileLength",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "useDefaultEnvironmentTexture",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "cameraPositionScale",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "cameraLimitLowerRadius",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "version",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "usedTextureUrls",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "SceneConfig",
        "kind": "LinkedField",
        "name": "config",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "SceneGeneralConfig",
            "kind": "LinkedField",
            "name": "general",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "backgroundAlpha",
                "storageKey": null
              },
              (v8/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "removeDefaultBackground",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "environmentTexture",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "EnvironmentOptions",
                "kind": "LinkedField",
                "name": "environmentOptions",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "mipMaps",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "generateHarmonics",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "gammaSpace",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "prefilterOnLoad",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "rotationY",
                    "storageKey": null
                  },
                  (v9/*:: as any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "pbrIntensity",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "matchSameNameTextures",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "antialiasEnabled",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "tryOnEnabled",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "SceneTryOnSettingsConfig",
                "kind": "LinkedField",
                "name": "tryOnSettings",
                "plural": false,
                "selections": [
                  (v10/*:: as any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "styleButton",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "SceneTryOnButtonCustomizationConfig",
                    "kind": "LinkedField",
                    "name": "buttonCustomizations",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "image",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "textLabel",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "textColor",
                        "storageKey": null
                      },
                      (v8/*:: as any*/),
                      (v11/*:: as any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "borderWidth",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "borderRadius",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "SceneTryOnTypeSettingsConfig",
                    "kind": "LinkedField",
                    "name": "typeSettings",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "try_on",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "pd",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "active",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "mandatoryPD",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "arEnabled",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "arOnTheFly",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "arAnchor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "arScale",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "ArMeshSize",
                "kind": "LinkedField",
                "name": "meshSize",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "height",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "width",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "depth",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "frameDAMSettings",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "useDelayedTextureLoading",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "useDelayedMaterialLoading",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "useMaterialOffloading",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "prefetchMeshes",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "prefetchMaterials",
                "storageKey": null
              },
              (v12/*:: as any*/),
              (v13/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "preventDefaultLights",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "forceDracoCompression",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "fitToScreenMargin",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "AntiAliasingOptions",
                "kind": "LinkedField",
                "name": "antialias",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "AntiAliasingDeviceOptions",
                    "kind": "LinkedField",
                    "name": "desktop",
                    "plural": false,
                    "selections": (v15/*:: as any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "AntiAliasingDeviceOptions",
                    "kind": "LinkedField",
                    "name": "mobile",
                    "plural": false,
                    "selections": (v15/*:: as any*/),
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "SceneEnvironmentConfig",
            "kind": "LinkedField",
            "name": "environment",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "sizeAuto",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "mainColor",
                "storageKey": null
              },
              (v8/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "SceneSkyboxConfig",
                "kind": "LinkedField",
                "name": "skybox",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "createSkybox",
                    "storageKey": null
                  },
                  (v16/*:: as any*/),
                  (v17/*:: as any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "extensions",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "files",
                    "storageKey": null
                  },
                  (v18/*:: as any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "blur",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "SceneGroundConfig",
                "kind": "LinkedField",
                "name": "ground",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "createGround",
                    "storageKey": null
                  },
                  (v16/*:: as any*/),
                  (v17/*:: as any*/),
                  (v18/*:: as any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "opacity",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "enableShadow",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "shadowLevel",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "enableMirror",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "mirrorBlurKernel",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "SceneShadowsConfig",
                "kind": "LinkedField",
                "name": "shadows",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "enableShadows",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "groundSizeMultiplierWidth",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "groundSizeMultiplierLength",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "shadowMapSize",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "shadowHexColor",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "contactHardeningUVRatio",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "useContactHardeningShadow",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "useBlurCloseExponentialShadowMap",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "usePercentageCloserFiltering",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "useKernelBlur",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "usePoissonSampling",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "blurBoxOffset",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "blurScale",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "blurKernel",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "depthScale",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "shadowDarkness",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "shadowMinZ",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "shadowMaxZ",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "SceneLightsConfig",
            "kind": "LinkedField",
            "name": "lights",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "SceneLightSetting",
                "kind": "LinkedField",
                "name": "directionalLightBack",
                "plural": false,
                "selections": (v20/*:: as any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "SceneLightSetting",
                "kind": "LinkedField",
                "name": "directionalLightLeft",
                "plural": false,
                "selections": (v20/*:: as any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "SceneLightSetting",
                "kind": "LinkedField",
                "name": "pointLightBack",
                "plural": false,
                "selections": (v20/*:: as any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "SceneLightSetting",
                "kind": "LinkedField",
                "name": "pointLightFront",
                "plural": false,
                "selections": (v20/*:: as any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "SceneLightSetting",
                "kind": "LinkedField",
                "name": "hemisphereLight",
                "plural": false,
                "selections": (v20/*:: as any*/),
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "SceneCameraConfig",
            "kind": "LinkedField",
            "name": "camera",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "autoRotate",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "rotationSpeed",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "changeRotationDirection",
                "storageKey": null
              },
              (v13/*:: as any*/),
              (v12/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "toneMappingEnabled",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "toneMappingType",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "setInitialZoomToBoundingBox",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "initialZoomToBBInertiaDamping",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "initialZoomToBBModelSizeRadius",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "initialZoomToBBScrollZoomEnabled",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "initialZoomToBBScrollLowerLimit",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "initialZoomToBBScrollUpperLimit",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "positionScale",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "limitLowerRadius",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "zoomEnabled",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "useMinZoomPerc",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "minZoomPerc",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "useMaxZoomPerc",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "maxZoomPerc",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "lowerAlphaLimit",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "upperAlphaLimit",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "lowerBetaLimit",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "upperBetaLimit",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "fixedAlphaAngle",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "fixedBetaAngle",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "useLowerAlphaLimit",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "useUpperAlphaLimit",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "useLowerBetaLimit",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "useUpperBetaLimit",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "SceneCameraPosition",
                "kind": "LinkedField",
                "name": "position",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "alpha",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "beta",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "radius",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "fov",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "animateIntro",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "zoom",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "SceneGlowConfig",
            "kind": "LinkedField",
            "name": "glow",
            "plural": false,
            "selections": [
              (v14/*:: as any*/),
              (v9/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "blurSize",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "SceneInfoPointsConfig",
            "kind": "LinkedField",
            "name": "infoPoints",
            "plural": false,
            "selections": [
              (v14/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "SceneInfoPointsStyleConfig",
                "kind": "LinkedField",
                "name": "pointsStyle",
                "plural": false,
                "selections": [
                  (v11/*:: as any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "innerPointColor",
                    "storageKey": null
                  },
                  (v18/*:: as any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "highlightColor",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "SceneUIConfig",
            "kind": "LinkedField",
            "name": "uiConfig",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "urlARIcon",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "urlLoader",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "SceneTexturesConfig",
            "kind": "LinkedField",
            "name": "textures",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "format",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "WebPOptions",
                "kind": "LinkedField",
                "name": "webpOptions",
                "plural": false,
                "selections": [
                  (v10/*:: as any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "quality",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "SceneModelConfig",
            "kind": "LinkedField",
            "name": "model",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "SceneModelCoordinate",
                "kind": "LinkedField",
                "name": "rotation",
                "plural": false,
                "selections": (v19/*:: as any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "SceneModelCoordinate",
                "kind": "LinkedField",
                "name": "position",
                "plural": false,
                "selections": (v19/*:: as any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "SceneModelCoordinate",
                "kind": "LinkedField",
                "name": "scale",
                "plural": false,
                "selections": (v19/*:: as any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "SceneModelConfigOption",
                "kind": "LinkedField",
                "name": "config",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "doubleSided",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "SceneAnimationsConfig",
            "kind": "LinkedField",
            "name": "animations",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "runAtStart",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "loop",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "speed",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "SceneSource",
        "kind": "LinkedField",
        "name": "sources",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "sourceID",
            "storageKey": null
          },
          (v2/*:: as any*/),
          (v3/*:: as any*/),
          (v4/*:: as any*/),
          (v5/*:: as any*/),
          (v6/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "SceneSourceTexture",
            "kind": "LinkedField",
            "name": "textures",
            "plural": true,
            "selections": [
              (v21/*:: as any*/),
              (v2/*:: as any*/),
              (v3/*:: as any*/),
              (v6/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "SceneCameraLocation",
        "kind": "LinkedField",
        "name": "cameraLocations",
        "plural": true,
        "selections": [
          (v22/*:: as any*/),
          (v1/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "px",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "py",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "pz",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "tx",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "ty",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "tz",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "SceneMaterialMapping",
        "kind": "LinkedField",
        "name": "materialMappings",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "sceneMaterialID",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "libraryMaterialID",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "SceneTexture",
        "kind": "LinkedField",
        "name": "textures",
        "plural": true,
        "selections": [
          (v21/*:: as any*/),
          (v23/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isDefaultEnvironment",
            "storageKey": null
          },
          (v2/*:: as any*/),
          (v3/*:: as any*/),
          (v6/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "usage",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "SceneMaterialPhoto",
        "kind": "LinkedField",
        "name": "materialPhotos",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "photoID",
            "storageKey": null
          },
          (v23/*:: as any*/),
          (v24/*:: as any*/),
          (v2/*:: as any*/),
          (v3/*:: as any*/),
          (v6/*:: as any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "SceneShaderMaterial",
        "kind": "LinkedField",
        "name": "shaderMaterials",
        "plural": true,
        "selections": [
          (v23/*:: as any*/),
          (v1/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "vertex",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "fragment",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "SceneMeshLocation",
        "kind": "LinkedField",
        "name": "meshLocations",
        "plural": true,
        "selections": [
          (v22/*:: as any*/),
          (v1/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "tempImageFileKey",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "tempImageFileUrl",
            "storageKey": null
          },
          (v7/*:: as any*/),
          (v24/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isCollapsed",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isExploded",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "adjustCamera",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "data",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "existingSceneDataWithSceneQuery",
    "selections": (v25/*:: as any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "existingSceneDataWithSceneQuery",
    "selections": (v25/*:: as any*/)
  },
  "params": {
    "cacheID": "7a0f61c094076cb64e787ba52947b7fa",
    "id": null,
    "metadata": {},
    "name": "existingSceneDataWithSceneQuery",
    "operationKind": "query",
    "text": "query existingSceneDataWithSceneQuery(\n  $sceneId: String!\n) {\n  scene(id: $sceneId) {\n    id\n    sceneIDforPagination\n    sceneID\n    tempSceneID\n    name\n    fileObjectID\n    url\n    rootUrl\n    sceneFileName\n    fileLength\n    manifestFileObjectID\n    manifestFileUrl\n    manifestFileLength\n    incrementalsFileObjectID\n    incrementalsFileUrl\n    incrementalsFileLength\n    sellerID\n    imageUrl\n    imageData\n    imageFileLength\n    useDefaultEnvironmentTexture\n    cameraPositionScale\n    cameraLimitLowerRadius\n    version\n    usedTextureUrls\n    config {\n      general {\n        backgroundAlpha\n        backgroundColor\n        removeDefaultBackground\n        environmentTexture\n        environmentOptions {\n          mipMaps\n          generateHarmonics\n          gammaSpace\n          prefilterOnLoad\n          rotationY\n          intensity\n          pbrIntensity\n        }\n        matchSameNameTextures\n        antialiasEnabled\n        tryOnEnabled\n        tryOnSettings {\n          type\n          styleButton\n          buttonCustomizations {\n            image\n            textLabel\n            textColor\n            backgroundColor\n            borderColor\n            borderWidth\n            borderRadius\n          }\n          typeSettings {\n            try_on\n            pd\n            active\n            mandatoryPD\n          }\n        }\n        arEnabled\n        arOnTheFly\n        arAnchor\n        arScale\n        meshSize {\n          height\n          width\n          depth\n        }\n        frameDAMSettings\n        useDelayedTextureLoading\n        useDelayedMaterialLoading\n        useMaterialOffloading\n        prefetchMeshes\n        prefetchMaterials\n        exposure\n        contrast\n        preventDefaultLights\n        forceDracoCompression\n        fitToScreenMargin\n        antialias {\n          desktop {\n            enabled\n            inRotationEnabled\n          }\n          mobile {\n            enabled\n            inRotationEnabled\n          }\n        }\n      }\n      environment {\n        sizeAuto\n        mainColor\n        backgroundColor\n        skybox {\n          createSkybox\n          size\n          texture\n          extensions\n          files\n          color\n          blur\n        }\n        ground {\n          createGround\n          size\n          texture\n          color\n          opacity\n          enableShadow\n          shadowLevel\n          enableMirror\n          mirrorBlurKernel\n        }\n        shadows {\n          enableShadows\n          groundSizeMultiplierWidth\n          groundSizeMultiplierLength\n          shadowMapSize\n          shadowHexColor\n          contactHardeningUVRatio\n          useContactHardeningShadow\n          useBlurCloseExponentialShadowMap\n          usePercentageCloserFiltering\n          useKernelBlur\n          usePoissonSampling\n          blurBoxOffset\n          blurScale\n          blurKernel\n          depthScale\n          shadowDarkness\n          shadowMinZ\n          shadowMaxZ\n        }\n      }\n      lights {\n        directionalLightBack {\n          position {\n            x\n            y\n            z\n          }\n          general {\n            intensity\n            visible\n          }\n        }\n        directionalLightLeft {\n          position {\n            x\n            y\n            z\n          }\n          general {\n            intensity\n            visible\n          }\n        }\n        pointLightBack {\n          position {\n            x\n            y\n            z\n          }\n          general {\n            intensity\n            visible\n          }\n        }\n        pointLightFront {\n          position {\n            x\n            y\n            z\n          }\n          general {\n            intensity\n            visible\n          }\n        }\n        hemisphereLight {\n          position {\n            x\n            y\n            z\n          }\n          general {\n            intensity\n            visible\n          }\n        }\n      }\n      camera {\n        autoRotate\n        rotationSpeed\n        changeRotationDirection\n        contrast\n        exposure\n        toneMappingEnabled\n        toneMappingType\n        setInitialZoomToBoundingBox\n        initialZoomToBBInertiaDamping\n        initialZoomToBBModelSizeRadius\n        initialZoomToBBScrollZoomEnabled\n        initialZoomToBBScrollLowerLimit\n        initialZoomToBBScrollUpperLimit\n        positionScale\n        limitLowerRadius\n        zoomEnabled\n        useMinZoomPerc\n        minZoomPerc\n        useMaxZoomPerc\n        maxZoomPerc\n        lowerAlphaLimit\n        upperAlphaLimit\n        lowerBetaLimit\n        upperBetaLimit\n        fixedAlphaAngle\n        fixedBetaAngle\n        useLowerAlphaLimit\n        useUpperAlphaLimit\n        useLowerBetaLimit\n        useUpperBetaLimit\n        position {\n          alpha\n          beta\n          radius\n          fov\n        }\n        animateIntro\n        zoom\n      }\n      glow {\n        enabled\n        intensity\n        blurSize\n      }\n      infoPoints {\n        enabled\n        pointsStyle {\n          borderColor\n          innerPointColor\n          color\n          highlightColor\n        }\n      }\n      uiConfig {\n        urlARIcon\n        urlLoader\n      }\n      textures {\n        format\n        webpOptions {\n          type\n          quality\n        }\n      }\n      model {\n        rotation {\n          x\n          y\n          z\n        }\n        position {\n          x\n          y\n          z\n        }\n        scale {\n          x\n          y\n          z\n        }\n        config {\n          doubleSided\n        }\n      }\n      animations {\n        runAtStart\n        loop\n        speed\n      }\n    }\n    sources {\n      sourceID\n      fileObjectID\n      url\n      rootUrl\n      sceneFileName\n      fileLength\n      textures {\n        textureID\n        fileObjectID\n        url\n        fileLength\n      }\n    }\n    cameraLocations {\n      locationID\n      name\n      px\n      py\n      pz\n      tx\n      ty\n      tz\n    }\n    materialMappings {\n      sceneMaterialID\n      libraryMaterialID\n    }\n    textures {\n      textureID\n      materialID\n      isDefaultEnvironment\n      fileObjectID\n      url\n      fileLength\n      usage\n    }\n    materialPhotos {\n      photoID\n      materialID\n      displayOrder\n      fileObjectID\n      url\n      fileLength\n    }\n    shaderMaterials {\n      materialID\n      name\n      vertex\n      fragment\n    }\n    meshLocations {\n      locationID\n      name\n      tempImageFileKey\n      tempImageFileUrl\n      imageUrl\n      displayOrder\n      isCollapsed\n      isExploded\n      adjustCamera\n      data\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "cd2f6a2dce5c94463e2da9e8fe39b516";

export default node;
